function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.3587 5.178c.1273.1415.191.2122.2182.2923.0309.0905.0309.1904 0 .2809-.0272.08-.0908.1508-.2182.2923L7.1859 12.9023c-.1273.1415-.191.2122-.2631.2425-.0814.0342-.1714.0342-.2528 0-.072-.0302-.1357-.101-.2631-.2425L3.0413 9.1627C2.9139 9.0212 2.8503 8.9505 2.8231 8.8704c-.0308-.0905-.0308-.1904 0-.2809.0272-.08.0909-.1508.2182-.2923l.8189-.9099c.1273-.1415.191-.2122.2631-.2425.0814-.0342.1714-.0342.2528 0 .072.0302.1357.101.2631.2425L6.4069 9.3515c.4101.4557.3471.4798.779 0L11.7608 4.2681c.1273-.1415.191-.2122.263-.2425.0815-.0342.1715-.0342.2529 0 .072.0302.1357.101.2631.2425l.8189.9099Z",
  fill: "#333333"
});

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 2,
  y: 2,
  width: 12,
  height: 12,
  stroke: "#000000",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/CheckboxChecked.f03d3ba6.svg";
export { SvgComponent as ReactComponent };